const adjectives = [
  'Brave', 'Noble', 'Swift', 'Mighty', 'Wise',
  'Valiant', 'Royal', 'Silent', 'Shadow', 'Iron',
  'Golden', 'Silver', 'Bronze', 'Crystal', 'Storm'
];

const nouns = [
  'Knight', 'Warrior', 'Hunter', 'Mage', 'Ranger',
  'Guardian', 'Wanderer', 'Seeker', 'Champion', 'Scout',
  'Blade', 'Shield', 'Arrow', 'Spell', 'Crown'
];

export function generateGuestUsername(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  
  return `${adjective}${noun}${number}`;
}